let API_URL       = "https://my.siil.ch/api/v1/";
let REACT_APP_ENV = process.env.REACT_APP_MODE || "development";
let API_WS_ROOT   = "wss://my.siil.ch/cable";
let DOMAIN        = ".siil.ch";
let URL           = "https://my.siil.ch"

if (REACT_APP_ENV === "staging") {
  // API_URL         = "https://my-siil-ch.vshp.tech/api/v1/";
  // API_WS_ROOT     = "wss://my-siil-ch.vshp.tech/cable";
  DOMAIN          = "siil-ch.vshp.tech";
  URL             = "https://my-siil-ch.vshp.tech";
} else if (REACT_APP_ENV === "development") {
  // API_URL         = "https://my-siil-ch.vshp.tech/api/v1/";
  // API_WS_ROOT     = "wss://my-siil-ch.vshp.tech/cable";
  DOMAIN          = "localhost";
  URL             = "https://my-siil-ch.vshp.tech";
}

console.log("App environment is set to " + REACT_APP_ENV);

export { API_URL, REACT_APP_ENV, API_WS_ROOT, DOMAIN, URL };
